import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { INTERFACE_MODES } from '../../helpers/interface-mode';
import { performInterfaceModeSwitch } from '../../helpers/apply-interface-mode';
import { dismissOffcanvasThen } from '../../helpers/offcanvas-cleanup';
import '../../assets/css/interface-mode-toggle.css';

const LABELS = {
    [INTERFACE_MODES.SELLER]: 'Switch to Seller Mode',
    [INTERFACE_MODES.BUYER]: 'Switch to Buyer Mode',
};

/**
 * Profile menu toggle for switching buyer/seller interface mode.
 * Reused in buyer and seller header profile dropdowns and mobile side menu.
 */
const InterfaceModeProfileMenuItem = ({
    targetMode,
    onAfterClick,
    variant = 'dropdown',
}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const userInfo = useSelector((state) => state.auth.userInfo);
    const interfaceMode = useSelector((state) => state.interfaceMode.mode);

    const isChecked = interfaceMode === targetMode;
    const oppositeMode =
        targetMode === INTERFACE_MODES.SELLER
            ? INTERFACE_MODES.BUYER
            : INTERFACE_MODES.SELLER;

    const handleToggleChange = (event) => {
        event.stopPropagation();

        const nextMode = event.target.checked ? targetMode : oppositeMode;

        dismissOffcanvasThen('sideMenu', () => {
            performInterfaceModeSwitch({
                dispatch,
                history,
                targetMode: nextMode,
                authState: { isLoggedIn, userInfo },
                replace: false,
                onAfterNavigate: onAfterClick,
            });
        });
    };

    const itemClassName =
        variant === 'side'
            ? 'interface-mode-menu-item interface-mode-menu-item--side'
            : 'interface-mode-menu-item interface-mode-menu-item--dropdown';

    return (
        <li className={itemClassName}>
            <div className="interface-mode-toggle-row">
                <span className="interface-mode-toggle-label">{LABELS[targetMode]}</span>
                <label className="interface-mode-switch" aria-label={LABELS[targetMode]}>
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleToggleChange}
                    />
                    <span className="interface-mode-switch-slider" />
                </label>
            </div>
        </li>
    );
};

export default InterfaceModeProfileMenuItem;
